// UI
import { ActivateEmail } from "@/components/auth/ActivateEmail"
import { RecoveryCodes } from "@/components/auth/RecoveryCodes"
import { Card } from "@/components/Card"
import { SignInForm } from "@/components/forms/SignIn"
import { TwoFactorAuthForm } from "@/components/forms/TwoFactorAuthForm"
import { SecondaryHeading } from "@/components/Typography"
import { SignInProvider, useSignIn } from "@/context/signIn"

// Translate
import { Trans, useTrans } from "@/i18n"

// Router
import { Link } from "@/lib/router"
import { Routes } from "@/constants/routes"

/**
 * SignIn
 * @returns
 */
export const SignIn = () => {
	const t = useTrans("sign-in")

	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("sign-in:sign-in.title"),
				})}
			</title>
			<SignInProvider>
				<div className="mb-8 mt-20 md:mb-24 md:mt-10">
					<div className="mb-6">
						<Header />
					</div>
					<div className="text-sm">
						<Forms />
					</div>
					<Notice />
				</div>
			</SignInProvider>
		</>
	)
}

const Header = () => {
	const { state } = useSignIn()
	const t = useTrans("sign-in")

	let langKey
	if (state === "activate-email") {
		langKey = "sign-in.activate_email.subtitle"
	} else if (state === "confirm") {
		langKey = "sign-in.code.confirm_login"
	}

	return (
		<div className="text-center" data-testid={state}>
			{langKey && (
				<SecondaryHeading styleAs="h2" className="mt-6 md:mb-9">
					{t(langKey)}
				</SecondaryHeading>
			)}
		</div>
	)
}

const Notice = () => {
	return (
		<Card className="mt-6 text-sm">
			<p>
				<Trans
					ns="sign-in"
					i18nKey="sign-in:sign-in.no_account_prompt"
					components={{
						Link: (
							<Link
								to={Routes.Register}
								data-testid="sign-in.no_account_prompt"
								className="font-medium text-secondary-300 hover:text-secondary-700"
							/>
						),
					}}
				/>
			</p>
		</Card>
	)
}

const Forms = () => {
	const { state } = useSignIn()

	return (
		<>
			{state === "sign-in" && <SignInForm />}
			{state === "recovery-codes" && <RecoveryCodes />}
			{state === "activate-email" && <ActivateEmail />}
			{state === "confirm" && <TwoFactorAuthForm />}
		</>
	)
}
